/**
 * Static registry of myai backend deployments the Excel add-in can talk to.
 *
 * Each entry maps a tenant id (the URL-safe string carried in the manifest's
 * ?tenant= query) to the API host and a human-readable display name.
 *
 * Add a new tenant by:
 *   1. Adding an entry here.
 *   2. Creating manifests/tenants/<id>.env with the per-tenant ADDIN_GUID,
 *      DISPLAY_NAME, TENANT_QUERY=?tenant=<id>, etc.
 *   3. Running `pnpm build:manifests`.
 *   4. Distributing the new manifest.<id>.xml to the tenant's M365 admin.
 *
 * No code changes elsewhere are required — getApiHost() resolves at runtime.
 */
export const TENANTS = {
  caplin: {
    apiHost: "https://api-caplin.makeyourself.ai",
    displayName: "myai (Caplin / Trillium)",
  },
  public: {
    apiHost: "https://api-public.makeyourself.ai",
    displayName: "myai",
  },
} as const;

export type TenantId = keyof typeof TENANTS;

export function isTenantId(id: string | null | undefined): id is TenantId {
  return id != null && id in TENANTS;
}
